export default {
  init() {
    $('.capital-video-wrap').on('click', function () {
      $('.capital-video-wrap').addClass('video-show');
      let capitalPlayer = $('.capital-video-wrap iframe');
      capitalPlayer.show();
      let capitalPlayerSrc = $('.capital-video-wrap iframe').attr('src');
      capitalPlayerSrc = capitalPlayerSrc+ '&autoplay=1';
      $(capitalPlayer).attr('src', capitalPlayerSrc);
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateCapitalCampaign.js